import styled, { keyframes } from "styled-components";
import { fadeIn } from "react-animations";
import backgroundImg from "../../../assets/images/background_nop.png";
import Color from "../../../assets/styles/colors";

const fadeInAnimation = keyframes`${fadeIn}`;

export const Container = styled.div`
  ${(props) =>
    !props.theme?.isDarkTheme && `background-image: url(${backgroundImg});`}
  height: 100%;
  background-size: cover !important;
  animation: 2s ${fadeInAnimation};
`;

export const ContainerItem = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Row = styled.div`
  flex: 1;
`;

export const Col = styled.div``;

export const Logo = styled.img``;

export const Item = styled.span`
  font-size: 12px;
`;

export const ItemLink = styled.span`
  color: #1c9763;
`;

export const RulesTime = styled.span`
  color: ${Color.colorRed};
`;

export const ItemContainer = styled.div`
  color: ${Color.textColorBlackOne};
  font-size: 12px;
`;

export const ContainerAnimation = styled.div`
  animation: 2s ${fadeInAnimation};
`;
